import 'core-js';
import 'reflect-metadata';

export * from 'tsyringe';
export type * from './lib/types';
export * from './lib/module';
export * from './lib/decorators';
export * from './lib/metadata/factory';
